import { render, staticRenderFns } from "./unitPower.vue?vue&type=template&id=3145656c&scoped=true&"
import script from "./unitPower.vue?vue&type=script&lang=js&"
export * from "./unitPower.vue?vue&type=script&lang=js&"
import style0 from "./unitPower.vue?vue&type=style&index=0&lang=css&"
import style1 from "./unitPower.vue?vue&type=style&index=1&id=3145656c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3145656c",
  null
  
)

export default component.exports